import React, { useState } from "react";
import Service from "../../Service";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@material-ui/core";
import CommonDialog from "../../../components/CommonDialog";

const ConfirmacionErroresVentana = () => {
  const [errores] = useState(
    JSON.parse(localStorage.getItem("confirmacionErroresNuevaVentana"))
  );

  const { res, enHora } = errores;

  const handleClose = () => {
    localStorage.removeItem("blankPageKey");
    localStorage.removeItem("confirmacionErroresNuevaVentana");
    window.close();
  };

  return (
    <CommonDialog
      open
      noCancelar={false}
      backgroundTitle={"rgb(241, 206, 47)"}
      disableBackdropClick
      fullScreen
      title={"Se encontraron los siguientes errores en las validaciones MEG"}
      margin="-20px"
      aceptarText={"IMPRIMIR"}
      cancelarText={"CERRAR"}
      onClickAceptar={() => {
        /* lee pega a service reerorsMg */
        Service.erroresMeg(
          res.codigoContratoOperador,
          res.numeroConfirmacion,
          enHora,
          res.validacionesMegMessages
        ).then((pdf) => {
          let url = URL.createObjectURL(
            new Blob([pdf], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        }).finally(handleClose);
      }}
      onClickCancelar={handleClose}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Número</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Detalle</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {res.validacionesMegMessages.map((row) => (
            <TableRow>
              <TableCell component="th" scope="row">
                {row.numeroLinea}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.tipo}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.detalle}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </CommonDialog>
  );
};

export default ConfirmacionErroresVentana;